<template>
  <div><PageTable /></div>
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'appManager-app-device-status',
  components: { PageTable },
}
</script>
